const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      fontFamily: theme.fonts[0],
      letterSpacing: '1px',
      '& > div:not(:last-child)': {
        marginBottom: 50,
      },
    },
    pretitle: {
      textTransform: 'uppercase',
      opacity: 0,
      fontSize: 16,
    },
    title: {
      position: 'relative',
      fontSize: 45,
      lineHeight: 1,
      opacity: 0,
      '& > *:only-child': {
        margin: 0,
      },
    },
    text: {
      fontSize: 24,
      lineHeight: 1.2,
      opacity: 0,
      '& > *:only-child': {
        margin: 0,
      },
      '& a': {
        fontStyle: 'italic',
        position: 'relative',
        color: 'currentColor',
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: 1,
          background: 'currentColor',
          bottom: 0,
          left: 0,
          transform: 'scaleX(0)',
          transformOrigin: 'left',
          transition: `transform 1s ${theme.easings['power4.out']}`,
        },
        '&:hover': {
          '&:before': {
            transform: 'scaleX(1)',
          },
        },
      },
      '& > *': {
        marginBottom: 0,
        '&:not(:last-child)': {
          marginBottom: 20,
        },
      },
      '& img': {
        width: '100%',
        height: 'auto',
      },
    },
    btn: {
      opacity: 0,
    },
    rootBtnLink: {
      '& $text': {
        '& a': {
          color: theme.colors[0],
          background: theme.colors[1],
          marginTop: 20,
          fontSize: 12,
          letterSpacing: 1,
          textTransform: 'uppercase',
          display: 'inline-block',
          padding: '8px 30px',
          borderRadius: 20,
          fontStyle: 'normal',
          verticalAlign: 'middle',
          transition: `background .3s ${theme.easings['power4.out']}, color .3s ${theme.easings['power4.out']}`,
          '&:before': {
            content: 'none',
          },
          '&:hover': {
          },
        },
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 30,
    },
    text: {
      fontSize: 16,
    },
  }

  return output
}

export default style
